import type { FetchConfig } from '../types'

import {
  configCacheFactory,
  configDefaultContentTypeFactory,
  configDialogFactory,
  configSablier,
  configUriHelperFactory,
  configConcurrency,
  configEncodeUrlAkto
} from '../extensions'
import { configBlocageImperso, configExtranet, extranetErrorFormater } from '@/features/api/extranet'

export const extranet = [
  configSablier,
  configEncodeUrlAkto,
  configDefaultContentTypeFactory('application/json'),
  configExtranet,
  configConcurrency,
  configDialogFactory(extranetErrorFormater),
  configUriHelperFactory(import.meta.env.VITE_API_EXTRANET),
  configCacheFactory(),
  configBlocageImperso,
] as Array<FetchConfig>
